import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=1400c316&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=1400c316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1400c316",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1400c316')) {
      api.createRecord('1400c316', component.options)
    } else {
      api.reload('1400c316', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=1400c316&scoped=true&", function () {
      api.rerender('1400c316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gRx526JSnqot/JS/comp/PopupBox.vue"
export default component.exports